export default function MediaKitPage() {
  return (
    <main className="bg-hero-radial">
      <section className="container-x py-14">
        <div className="glass p-8">
          <div className="flex flex-col gap-6 md:flex-row md:items-start md:justify-between">
            <div>
              <h1 className="text-3xl font-semibold tracking-tight">Media Kit</h1>
              <p className="mt-2 max-w-2xl text-white/65">
                Download brand assets and basic information for press, partnerships, and public sharing.
              </p>
            </div>
            <a
              className="inline-flex items-center justify-center rounded-full bg-primary px-5 py-2 text-sm font-semibold text-black transition hover:bg-[#12d584]"
              href="/assets/ic_splash_logo.png"
              download
            >
              Download logo
            </a>
          </div>

          <div className="mt-8 grid gap-6 md:grid-cols-2">
            <div className="glass2 p-6">
              <div className="text-sm font-medium text-white/80">One-liner</div>
              <div className="mt-2 text-white/70">
                Soulon builds personality memory and a multi-chain settlement layer: from 402 challenges to negotiation, execution plans, and
                auditable receipts—so promises can be shipped, verified, and reused.
              </div>
            </div>
            <div className="glass2 p-6">
              <div className="text-sm font-medium text-white/80">Brand colors</div>
              <div className="mt-4 flex flex-wrap gap-3">
                <ColorSwatch name="Background" value="#0A0A0F" />
                <ColorSwatch name="Primary" value="#14F195" />
                <ColorSwatch name="Secondary" value="#9945FF" />
                <ColorSwatch name="Surface" value="#141414" />
              </div>
            </div>
          </div>

          <div className="mt-8 glass2 p-6">
            <div className="text-sm font-medium text-white/80">Logo preview</div>
            <div className="mt-4 flex flex-wrap items-center gap-6">
              <div className="rounded-2xl border border-white/10 bg-black/30 p-6">
                <img
                  src="/assets/ic_splash_logo.png"
                  alt="Soulon logo"
                  className="h-20 w-20 object-contain"
                />
              </div>
              <div className="rounded-2xl border border-white/10 bg-white/5 p-6">
                <img
                  src="/assets/ic_splash_logo.png"
                  alt="Soulon logo"
                  className="h-20 w-20 object-contain"
                />
              </div>
            </div>
            <div className="mt-4 text-xs text-white/45">
              The logo is sourced from the repo at app/src/main/res/drawable/ic_splash_logo.png and copied to /assets/ during build.
            </div>
          </div>
        </div>
      </section>
    </main>
  )
}

function ColorSwatch(props: { name: string; value: string }) {
  return (
    <div className="flex items-center gap-3 rounded-xl border border-white/10 bg-white/5 px-3 py-2">
      <div className="h-6 w-6 rounded-lg border border-white/10" style={{ background: props.value }} />
      <div className="leading-tight">
        <div className="text-xs text-white/50">{props.name}</div>
        <div className="text-xs font-medium text-white/80">{props.value}</div>
      </div>
    </div>
  )
}
